import React from "react";
import { useSelector } from "react-redux";
import CarrinhoItem from "../../carrinho/carrinho-item";
import CarrinhoItemCard from "./carrinho-item-card";

function Carrinho({ apostas, apagaAposta, reusaAposta, arrSupertime, title }) {
  const isNewDesign = useSelector((state) => state.settings.isNewDesign);

  const isEmpty = !(
    (apostas && apostas.length > 0) ||
    (arrSupertime && arrSupertime.length > 0)
  );

  return (
    <React.Fragment>
      <div className="box-header modalidade-input-container-title">
        <h3 className="box-title col-md-6 " style={{ fontSize: "24px" }}>
          Carrinho
        </h3>
      </div>
      <div className="box-body" style={{ paddingBottom: "0px" }}>
        <ul className="list-group list-group-flush">
          {apostas &&
            apostas.length > 0 &&
            apostas.map((ap, index) => {
              if (!isNewDesign) {
                return (
                  <CarrinhoItem
                    aposta={ap}
                    apagaAposta={apagaAposta}
                    key={ap}
                    tipoJogo={ap.tipo}
                  />
                );
              }

              return (
                <CarrinhoItemCard
                  key={ap.Aposta_ID}
                  index={index}
                  apostaId={ap.Aposta_ID}
                  numeros={ap.numeros}
                  apagaAposta={apagaAposta}
                  reusaAposta={() => reusaAposta(...ap.resetParams)}
                  title={ap.tipo.vchNome}
                  subtotal={ap.valorTotal}
                  premio={ap.strPremiosVisualizacao}
                  tipoJogo={ap.tipo}
                />
              );
            })}

          {arrSupertime &&
            arrSupertime.length > 0 &&
            arrSupertime.map((supertime, index) => (
              <CarrinhoItemCard
                key={supertime.Aposta_ID}
                index={index}
                apagaAposta={apagaAposta}
                title={title}
                apostaId={supertime.Aposta_ID}
                subtotal={supertime.subtotal}
                leagues={supertime.league}
                teams={supertime.teams}
                enableSide={true}
                tipoJogo={supertime.tipo}
              />
            ))}

          {isEmpty && (
            <li className="list-group-item empty-cart">
              <div className="carrinho_row">
                <h4>Insira sua aposta</h4>
              </div>
            </li>
          )}
        </ul>
      </div>
    </React.Fragment>
  );
}

export default React.memo(Carrinho);



// WEBPACK FOOTER //
// ./src/newDesign/components/carrinho.jsx